import React, { useState, useRef, useEffect } from 'react';
import Heading from '../ui/Heading';

const specs = [
  {
    title: 'Structure',
    details: ['RCC framed structure.']
  },
  {
    title: 'Flooring',
    details: [
      'Vitrified tiles (600MM*1200MM) in living, dining and bedrooms (Naveen Tiles/ Nitco/ Somany or equivalent).',
      'Anti-skid ceramic tiles (600MM*600MM) for Kitchen,bathrooms, balconies and utility (Naveen Tiles / Nitco/ Somany or equivalent).'
    ]
  },
  {
    title: 'Windows',
    details: [
      '3 Track UPVC French windows with mosquito mesh for balcony.',
      '2.5 Track UPVC windows with mosquito mesh.',
      'Ventilators with glass louvers and provision for exhaust fans in all bathrooms'
    ]
  },
  {
    title: 'Kitchen',
    details: [
      'Adequate electrical and plumbing points including points for water purifier, chimney in the kitchen & washing machine in utility. Provision for sink and dish washer in utility.'
    ]
  },
  {
    title: 'Main Doors',
    details: [
      'Door Brands –Shreeji/Cuirass/ Ferro',
      'Pre-Hung Main Door (2100MM*1050MM) - 40MM shutter thickness engineered wood with wrapped LVL (Laminated Veneer Lumber) frames and veneer finish on both sides.',
      'Main Door – 4 in 1 Digital Lock of Yale/Godrej/Europa.'
    ]
  },
  {
    title: 'Bedroom Doors',
    details: [
      'Door Brands –Shreeji/Cuirass/ Ferro',
      'Pre-Hung Door (2100MM*900MM) - 35MM shutter thickness engineered wood with wrapped LVL (Laminated Veneer Lumber) frames and laminate finish on both sides.',
      'Cylindrical Lock System (Ball locks) with key of (Yale/Godrej/Europa).'
    ]
  },
  {
    title: 'Toilet Doors',
    details: [
      'Door Brands –Shreeji/Cuirass/ Ferro',
      'Pre-Hung Door(2100MM*750MM) - 35MM shutter thickness engineered wood with wrapped LVL (Laminated Veneer Lumber) frames and laminated finish on both sides.',
      'Cylindrical Lock System (Ball locks) of (Yale/Godrej/Europa).'
    ]
  },
  {
    title: 'Bathrooms',
    details: [
      'Glazed ceramic tiles dado (600MM*1200MM) of Naveen Tiles / Nitco/ Somany or equivalent make up to 7 feet height.',
      'White colour wall mounted commode with concealed flush system and basins of Kerovit/ RAK/Jaquar or equivalent make.',
      'Elegant CP fittings, faucets of Kerovit/ RAK/Jaquar or equivalent make.',
      'Hot and cold single lever diverter with bath and overhead shower unit of Kerovit/ RAK/Jaquar or equivalent make.',
      'Provision for geyser and exhaust fan in all bathrooms.',
      'Pressure checked plumbing and drainage lines to ensure leak proof toilets.'
    ]
  },
  {
    title: 'Electrical',
    details: [
      'Good quality fire resistant and low smock copper cables (Anchor/Greatwhite/Polycab or equivalent make).',
      'One Earth Leakage Circuit Breaker (ELCB) for each apartment.',
      'Elegant modular switches of Anchor/Greatwhite/Polycab or equivalent make.',
      'Adequate light, fan and plug points.',
      'TV points in living, Master bedroom and provision in all other bedrooms.',
      'A/C point in master bedroom and provision for all other bedrooms & living.',
      '5 KW power supply (BESCOM) for all apartments.',
      '100% DG back up for common areas and 1.0 KVA backup for individual apartment.',
      'Solar power connection for all common areas.',
      'Provision for EV charging in individual parking lots.',
    ]
  },
  {
    title: 'Paint',
    details: [
      'Weatherproof acrylic exterior emulsion paint for external walls.',
      'Acrylic emulsion paint for interior walls and ceiling.',
      'Enamel paint for all MS works.'
    ]
  },
  {
    title: 'Lifts',
    details: ['2 No’s ( 8 passenger) lifts of Otis/Schindler/Kone or equivalent make.']
  },
  {
    title: 'Car Parking',
    details: ['One covered car parking per apartment.']
  }
];

const AccordionItem = ({ item, isOpen, onClick, index }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);
    
    useEffect(() => {
      if (isOpen) {
        const contentEl = contentRef.current;
        setHeight(contentEl.scrollHeight);
      } else {
        setHeight(0);
      }
    }, [isOpen]);
  
    return (
      <div className="border-b border-gray-200 last:border-b-0">
        <button
          className="w-full flex justify-between items-center py-4 text-left text-lg sm:text-xl text-gray-700 hover:text-gray-900 transition-colors focus:outline-none"
          onClick={onClick}
        >
          {item.title}
          <span 
            className={`text-2xl sm:text-3xl text-gray-500 transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-45 transform' : ''}`}
          >
            +
          </span>
        </button>
        <div 
          ref={contentRef}
          style={{ height: `${height}px` }}
          className="overflow-hidden transition-all duration-300 ease-in-out"
        >
          <ul className="pb-4 pl-4 text-gray-600 space-y-2">
            {item.details.map((detail, idx) => (
              <li key={idx} className="flex items-start">
                <span className="mr-2 mt-3 block w-1 h-1 rounded-full bg-gray-400"></span>
                <span>{detail}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };
  
  const ProjectSpecifications = () => {
    const [openIndex, setOpenIndex] = useState(null);
  
    const toggleIndex = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };
  
    return (
      <div className="mx-auto p-6 bg-white py-8 sm:py-12 lg:py-16">
        <Heading level={2} className='text-center mb-8'>Project Specifications</Heading>
        <div className="space-y-2 max-w-4xl m-auto">
          {specs.map((item, index) => (
            <AccordionItem 
              key={index}
              item={item}
              isOpen={openIndex === index}
              onClick={() => toggleIndex(index)}
              index={index}
            />
          ))}
        </div>
      </div>
    );
  };
  
  export default ProjectSpecifications;